import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CategoryService } from 'src/app/_services/category.service';
import { ExternalConnectionService } from 'src/app/_services/externalConn.service';

@Component({
  selector: 'app-external-conn-config',
  templateUrl: './external-conn-config.component.html',
  styleUrls: ['./external-conn-config.component.scss']
})
export class ExternalConnConfigComponent implements OnInit {
  allExternalConnections: any
  tableDataSource: MatTableDataSource<any>
  displayedColumns = ["name", "url", "active", "actions"]
  name: string;
  url: string;
  openForm: boolean = false
  externalConnectionForm: FormGroup
  allCategories = []
  categoryID
  searchCtrl
  categoryProperties = ["Document ID"]
  authorization = [{ name: "Basic Authorization with Credentials", value: "basicauth:cred" }, { name: "No Authorization Required", value: "noauth" }, { name: "Basic Authorization with token", value: "basicauth:token" }]
  auth
  username: string
  password: string
  auth_url: string
  button: string = "Save"
  method: string
  methods = ["GET", "PUT", "DELETE", "POST"]
  formColumns=["Name", "Value", "Required", "Use Category Metadata"]
  externalConnectionId: number;

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.tableDataSource.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.tableDataSource.paginator = this.paginator;
    }
  }

  constructor(
    private extConnService: ExternalConnectionService,
    private categoryService: CategoryService,
  ) { }

  ngOnInit() {
    this.getAllConnections()
    this.getAllCategories()
    this.newForm()
  }

  getAllConnections() {
    this.extConnService.getAllExternalConnections().subscribe(resp => {
      this.allExternalConnections = resp
      this.tableDataSource = new MatTableDataSource(this.allExternalConnections)
      this.tableDataSource.sort = this.sort;
      this.tableDataSource.paginator = this.paginator;
    })
  }

  getAllCategories() {
    this.categoryService.getAll().subscribe(resp => {
      this.allCategories = resp['results']
    })
  }

  newForm() {
    this.externalConnectionForm = new FormGroup({
      conn_name: new FormControl('', Validators.required),
      conn_url: new FormControl('', Validators.required),
      param: new FormArray([this.initParams()]),
      body: new FormArray([this.initParams()]),
    })
  }

  CreateExternalConn() {
    this.button = "Save"
    this.openForm = true
    this.newForm()
    this.categoryProperties = ["Document ID"]
    this.externalConnectionId = null
  }

  initParams() {
    return new FormGroup({
      name: new FormControl('', Validators.required),
      value: new FormControl('', Validators.required),
      dynamic: new FormControl(false, Validators.required),
      required: new FormControl(false, Validators.required)
    });
  }

  addParam() {
    const control = <FormArray>this.externalConnectionForm.get('param');
    control.push(this.initParams());
  }

  addBody() {
    const control = <FormArray>this.externalConnectionForm.get('body');
    control.push(this.initParams());
  }

  getParam(form) {
    return form.controls.param.controls;
  }

  getBody(form) {
    return form.controls.body.controls;
  }

  deleteParam(index: number) {
    this.paramArray.removeAt(index);
  }

  deleteBody(index: number) {
    this.bodyArray.removeAt(index);
  }

  get paramArray() {
    return <FormArray>this.externalConnectionForm.get("param")
  }

  get bodyArray() {
    return <FormArray>this.externalConnectionForm.get("body")
  }

  getCategoryProperties(categoryId) {
    // this.categoryProperties = ["Document ID"]
    for (let category of this.allCategories) {
      if (category.id == categoryId) {
        for (let metaData of category.meta_data_definition) {
          if (metaData.active) {
            for (let property of metaData.properties) {
              this.categoryProperties.push(property.name)
            }
          }
        }
      }
    }
    this.categoryProperties = this.categoryProperties.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem
      }
    })
  }

  updateExternalConnection(externalConnection) {
    this.button = "Update"
    this.externalConnectionId = externalConnection.system_id
    if (externalConnection.connection_parameters.param) {
      externalConnection.connection_parameters.param.forEach(element => {
        if (element.value.includes(":")) {
          if (element.value.split(":")[0] == 0) {
            element.value = "Document ID"
          } else {
            this.categoryID = parseInt(element.value.split(":")[0])
            this.getCategoryProperties(element.value.split(":")[0])
            element.value = element.value.split(":")[1]
          }
        }
        this.addParam()
      });
    } else {
      externalConnection.connection_parameters.param = []
    }
    this.deleteParam(externalConnection.connection_parameters.param.length)

    if (externalConnection.connection_parameters.body) {
      externalConnection.connection_parameters.body.forEach((element, index) => {
        if (element.value.includes(":")) {
          if (element.value.split(":")[0] == 0) {
            element.value = "Document ID"
          } else {
            this.categoryID = parseInt(element.value.split(":")[0])
            this.getCategoryProperties(element.value.split(":")[0])
            element.value = element.value.split(":")[1]
          }
        }
        this.addBody()
      });
    } else {
      externalConnection.connection_parameters.body = []
    }
    this.deleteBody(externalConnection.connection_parameters.body.length)

    var obj = {
      conn_name: externalConnection.system_name,
      conn_url: externalConnection.connection_url,
      param: externalConnection.connection_parameters.param,
      body: externalConnection.connection_parameters.body,
    }
    this.auth = externalConnection['connection_parameters']['auth']
    this.auth_url = externalConnection['connection_parameters']['auth_url']
    this.username = externalConnection['connection_parameters']['username']
    this.password = externalConnection['connection_parameters']['password']
    this.method = externalConnection['connection_parameters']['method']
    this.externalConnectionForm.patchValue(obj)
    this.openForm = true
  }

  deleteExternalConnection(externalConnection) {
    this.extConnService.deleteExternalConnection(externalConnection.system_id).subscribe(resp => {
      this.back()
    })
  }

  save() {
    var payload = Object.assign({}, this.externalConnectionForm.value)
    payload.conn_param = {
      auth: this.auth,
      method: this.method,
      param: payload.param,
      body: payload.body
    }
    delete payload.param
    delete payload.body
    switch (payload["conn_param"]["auth"]) {
      case "basicauth:cred":
        payload["conn_param"]["username"] = this.username
        payload["conn_param"]["password"] = this.password
        break;
      case "basicauth:token":
        payload["conn_param"]["username"] = this.username
        payload["conn_param"]["password"] = this.password
        payload["conn_param"]["auth_url"] = this.auth_url
        break;
    }
    payload["conn_param"].body.forEach(element => {
      if (element.dynamic) {
        if (element.value == "Document ID") {
          element.value = "0:document_id"
        } else { element.value = this.categoryID + ":" + element.value }
      }
    });
    payload["conn_param"].param.forEach(element => {
      if (element.dynamic) {
        if (element.value == "Document ID") {
          element.value = "0:document_id"
        } else { element.value = this.categoryID + ":" + element.value }
      }
    });
    this.extConnService.createExternalConnection(payload).subscribe(resp => {
      this.back()
      this.getAllConnections()
      this.externalConnectionId = null
    })
  }

  update() {
    var payload = Object.assign({}, this.externalConnectionForm.value)
    payload.conn_param = {
      auth: this.auth,
      method: this.method,
      param: payload.param,
      body: payload.body
    }
    delete payload.param
    delete payload.body
    switch (payload["conn_param"]["auth"]) {
      case "basicauth:cred":
        payload["conn_param"]["username"] = this.username
        payload["conn_param"]["password"] = this.password
        break;
      case "basicauth:token":
        payload["conn_param"]["username"] = this.username
        payload["conn_param"]["password"] = this.password
        payload["conn_param"]["auth_url"] = this.auth_url
        break;
    }
    payload["conn_param"].body.forEach(element => {
      if (element.dynamic) {
        if (element.value == "Document ID") {
          element.value = "0:document_id"
        } else { element.value = this.categoryID + ":" + element.value }
      }
    });
    payload["conn_param"].param.forEach(element => {
      if (element.dynamic) {
        if (element.value == "Document ID") {
          element.value = "0:document_id"
        } else { element.value = this.categoryID + ":" + element.value }
      }
    });
    payload.conn_id = this.externalConnectionId
    this.extConnService.updateExternalConnection(payload).subscribe(resp => {
      this.back()
      this.getAllConnections()
      this.externalConnectionId = null
    })
  }

  back() {
    this.openForm = false;
    this.getAllConnections()
    this.newForm()
    this.auth = null
    this.auth_url = null
    this.username = null
    this.password = null
    this.categoryID = null
    this.categoryProperties = []
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.tableDataSource.filter = filterValue.trim().toLowerCase();

    if (this.tableDataSource.paginator) {
      this.tableDataSource.paginator.firstPage();
    }
  }

}
